import { CircularProgress } from "@mui/material";

const Loading = ({ sx = null }) => {
  return <CircularProgress sx={sx} />;
};

export default Loading;
